import React from "react";
import Modal from "components/UI/DialogModal";
import { CircularProgress, Grid, Stack } from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import { ICompanyDepartments } from "models/companyDepartment";
import Form from "components/UI/Form";
import { IFormField } from "models/app";
import { InputTypes } from "constants/enums";
import { ICompanyEmployees } from "models/company";

interface Props {
  open: boolean;
  loading: boolean;
  CompanyDepartments: ICompanyDepartments;
  companyEmployees:ICompanyEmployees[]
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditCompanyDepartment: React.FC<Props> = ({
  open,
  loading,
  onClose,
  onSubmit,
  onChanges,
  CompanyDepartments,
  companyEmployees
}) => {
  const { t } = useTranslation();


  const employeesOptions = companyEmployees.map(item=> {return {value: item.id , label : item.name}})
  let basicFields: IFormField[] = [
    {
      name: "name",
      label: t("T_name"),
      type: InputTypes.TEXT,
      defaultValue: CompanyDepartments.name,
      internalLabel: true,
      required: true,
    },
    {
      name: "nameAr",
      label: t("T_name_Ar"),
      type: InputTypes.TEXT,
      defaultValue: CompanyDepartments.nameAr,
      internalLabel: true,
      required: true,
    },
    {
      name: "headOfDepartment",
      label: t("T_hod"),
      type: InputTypes.SELECT,
      options:employeesOptions,
      defaultValue: employeesOptions.find(item => item.value === CompanyDepartments.headOfDepartment),
      internalLabel: true,
      required: true,
    },
    {
      name: "approvingOfficer",
      label: t("T_approving_officer"),
      type: InputTypes.SELECT,
      options:employeesOptions,
      defaultValue: employeesOptions.find(item => item.value === CompanyDepartments.approvingOfficer),
      internalLabel: true,
      required: true,
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_edit_department")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <Form fields={basicFields} onChange={onChanges} />
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={onSubmit}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default EditCompanyDepartment;
